import React from "react";
import Chip from "@mui/material/Chip";
import IconButton from "@mui/material/IconButton";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import EditOutlined from "@mui/icons-material/EditOutlined";
import FolderOutlined from "@mui/icons-material/FolderOutlined";
import { Link as RouterLink } from "react-router-dom";
import { IClientListItem } from "../../data/Clients";

interface ClientListTableRowProps {
  client: IClientListItem;
}

const ClientListTableRow = ({ client }: ClientListTableRowProps) => (
  <TableRow hover tabIndex={-1}>
    <TableCell scope="row" width="30%">
      {client.name}
    </TableCell>
    <TableCell align="left" width="60%">
      {client.sectors.map((sector) => (
        <Chip key={sector} size="small" label={sector} sx={{ m: "1px" }} />
      ))}
    </TableCell>
    <TableCell align="right" padding="none" width="10%">
      <IconButton
        href={client.folder}
        target="_blank"
        rel="noreferrer noopener"
      >
        <FolderOutlined />
      </IconButton>
      <IconButton component={RouterLink} to={`/clients/${client.id}/`}>
        <EditOutlined />
      </IconButton>
    </TableCell>
  </TableRow>
);

export default ClientListTableRow;
